import {ChangeDetectorRef, Component, EventEmitter, Output} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {FUIModalsService} from "@fedeltapointofsale/ui";

@Component({
    selector: "category-move-modal",
    templateUrl: "./category-move-modal.component.html"
})
export class CategoryMoveModalComponent {

    category: any;

    targetCategoryId: any;

    state: boolean = true;

    @Output() onConfirm: EventEmitter<number> = new EventEmitter();

    constructor(private translateService: TranslateService, private modalsService: FUIModalsService, private changeDetectorRef: ChangeDetectorRef) {
    }

    cancel(): void {
        this.modalsService.close(this);
        this.onConfirm.complete();
    }

    confirm(): void {
        this.modalsService.close(this);
        this.onConfirm.emit(this.targetCategoryId);
        this.onConfirm.complete();
    }
}
